// Shared, transport-independent representation of Pabs speaking to a person.
// This module is also used in React; keep filesystem/model calls out of it.
const COMMUNICATION_VERSION = 1;

function messageTexts(value) {
  const source = Array.isArray(value) ? value : value?.messages;
  if (!Array.isArray(source)) return [];
  return source.map(item => typeof item === 'string' ? item : item?.text)
    .filter(item => typeof item === 'string' && item.trim())
    .map(item => item.trim());
}

function normalizeCommunication(value, fallback = '') {
  const messages = messageTexts(value);
  // Paragraph boundaries in old records remain intact. Never slice sentences
  // or rewrite historical text merely to meet a display budget.
  const legacy = typeof fallback === 'string' ? fallback.trim() : '';
  return {
    version: COMMUNICATION_VERSION,
    messages: messages.length ? messages : legacy ? legacy.split(/\n\s*\n/).filter(Boolean) : [],
  };
}

function communicationText(value, fallback = '') {
  return normalizeCommunication(value, fallback).messages.join('\n\n');
}

function communicationPreview(value, fallback = '') {
  return normalizeCommunication(value, fallback).messages[0] || '';
}

function resultCommunication(result = {}) {
  return result.communication || result.review?.communication || result.assessment?.communication
    || result.comparison?.communication || result.system_usage_review?.communication
    || result.remediation?.communication || result.audit?.communication || result.brief?.communication || null;
}

function responseChoices(type, options) {
  if (type !== 'confirm' || !Array.isArray(options)) return [];
  return options.map((item, index) => {
    const label = typeof item === 'string' ? item : item?.label;
    const value = typeof item === 'string' ? item : item?.value || label;
    return typeof label === 'string' && label.trim() && typeof value === 'string'
      ? { id: `choice-${index + 1}`, label: label.trim(), value: value.trim() } : null;
  }).filter(Boolean);
}

function communicationIssues(value, { technicalValues = [] } = {}) {
  // Structural diagnostics only. Naturalness and identity need contextual
  // review; a growing phrase blacklist cannot establish either.
  const messages = messageTexts(value);
  const issues = [];
  if (!messages.length) issues.push('missing_messages');
  if (messages.some(text => text.split(/\s+/).length > 30)) issues.push('long_message');
  if (messages.some(text => /^\s*(?:#{1,6}\s|\*\*[^*\n]+:\*\*)/m.test(text))) issues.push('report_format');
  if (messages.some(text => technicalValues.some(value => typeof value === 'string' && value.length && text.includes(value)))) issues.push('technical_detail');
  return issues;
}

module.exports = { COMMUNICATION_VERSION, normalizeCommunication, communicationText, communicationPreview, resultCommunication, responseChoices, communicationIssues };
